import React, { useRef } from 'react';
import { Form, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { UploadFile } from 'antd';

const ImageUploader: React.FC = () => {
  const form = Form.useFormInstance();
  const dragIndex = useRef<number>(-1);

  const handleDrop = (dropIndex: number) => {
    if (dragIndex.current < 0 || dragIndex.current === dropIndex) return;
    const list: UploadFile[] = [...(form.getFieldValue('images') ?? [])];
    const [moved] = list.splice(dragIndex.current, 1);
    list.splice(dropIndex, 0, moved);
    form.setFieldValue('images', list);
    dragIndex.current = -1;
  };

  return (
    <Form.Item
      name="images"
      label="Фотографии товара"
      valuePropName="fileList"
      getValueFromEvent={e => Array.isArray(e) ? e : e?.fileList}
    >
      <Upload
        listType="picture-card"
        beforeUpload={() => false}
        multiple
        maxCount={5}
        showUploadList={{ showPreviewIcon: false }}
        itemRender={(originNode, file, fileList) => {
          const index = fileList.indexOf(file);
          return (
            <div
              draggable
              onDragStart={() => { dragIndex.current = index; }}
              onDragOver={e => e.preventDefault()}
              onDrop={() => handleDrop(index)}
            >
              {originNode}
            </div>
          );
        }}
      >
        <div>
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>Добавить</div>
        </div>
      </Upload>
    </Form.Item>
  );
};

export default ImageUploader;
